import { render } from "./admin-layout.vue?vue&type=template&id=778b2416&scoped=true"
import script from "./admin-layout.vue?vue&type=script&lang=js"
export * from "./admin-layout.vue?vue&type=script&lang=js"

import "./admin-layout.vue?vue&type=style&index=0&id=778b2416&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778b2416"]])

export default __exports__